<template>
  <div>
    <b-modal id="authModal" :title="pageTitle" header-bg-variant="primary" header-text-variant="light" size="xl" hide-footer>
      <auth-form v-bind:mode.sync="mode" :defaultMode="defaultMode" @onAuthComplete="onAuthComplete"></auth-form>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'AuthModal',
  mixins: [
  ],
  props: [
    'authBus'
  ],
  data() {
    return {
      defaultMode: 'login',
      mode: null
    };
  },
  computed: {
    pageTitle () {
      if (this.mode == 'login')
        return 'Log In to My NAB';
      else if (this.mode == 'signup')
        return 'Sign Up for My NAB';
      else if (this.mode == 'request')
        return 'Reset Password by Email';
    }    
  },
  methods: {
    onAuth: function (mode, callback) {
      this.defaultMode = mode;
      this.$bvModal.show('authModal');
    },
    onAuthComplete: function () {
      this.$bvModal.hide('authModal');

      this.$emit('onAuthComplete');
    }
  },
  mounted () {
    this.authBus.$on('openAuthForm', this.onAuth);
  }
}
</script>